import React from 'react'
import Button from "../../presentational/Button";
import LocalizedText from '../../presentational/LocalizedText';
import useTranslate from "../../../hooks/useTranslate";
import useAuthenticationStore, { AuthenticationViews } from './Store';

const SplashScreen: React.FC = () => {
  const { setActiveView } = useAuthenticationStore()

  const translations = useTranslate(['participant-login-join-info'])

  return (
    <div className="login-action splash-screen">
      <h1><LocalizedText textKey="participant-login-join-title" /></h1>
      <p dangerouslySetInnerHTML={{ __html: translations["participant-login-join-info"] }} />
      <div className="splash-buttons">
        <Button
          size="large"
          onClick={() => setActiveView(AuthenticationViews.join)}
          intent='primary'
          width='100%'
          className='primary-action'
        >
          <LocalizedText textKey='participant-login-join-label' />
        </Button>
        <Button
          size="large"
          onClick={() => setActiveView(AuthenticationViews.login)}
          intent='none'
          variant='minimal'
          width='100%'
          className='login-button'
        >
          <LocalizedText textKey='participant-login-login-label' />
        </Button>
      </div>
    </div >
  )
}

export default SplashScreen